'use strict';
var React = require('react');
var reactDom = require('react-dom');
var ReactRedux = require('react-redux');
var Store = require('../../redux/store.js');

if (window.APP == "backorders") {
    var BackordersPage = require('../../views/custom/backorders/index').BackordersLayout;

    const store = Store.createBackordersPageStore(window.REDUX_DATA);
    const app = document.getElementById("root");

    const renderMethod = module.hot ? reactDom.render : reactDom.hydrate;
        renderMethod(
            <ReactRedux.Provider suppressHydrationWarning={true} store={store}>
                <BackordersPage />
            </ReactRedux.Provider>,
            app
        );
}